module.exports = __webpack_public_path__ + "static/media/new_bg_small.a0b478ff.png";